var MpPageHome;

(function() {
    if (!document.querySelector('#vue-home')) {
        return;
    }

    MpPageHome = new Vue({
        el: '#vue-home',
        mixins: [MpVideoModal, MpLeadersBlock],

        data: {
            // FORM_URL: '',

            highlightsCarousel: null,
            participationsCarousel: null,
            notesCarousel: null,

            /*
            name: '',
            phone: '',
            email: '',
            message: ' ',
            fsecure: '',
            privacity: false,

            errors: [],
            successMessage: '',
            validated: false,
            */

            isLegalShown: false,
            isInitialized: false,
        },

        computed: {

            /*
            nameCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.name);
            },

            emailCheck: function() {
                return !this.validated || FormValidator.isValidEmail(this.email);
            },

            phoneCheck: function() {
                return !this.validated || (!this.contactPhone && FormValidator.isEmpty(this.phone)) || FormValidator.isNumber(this.phone);
            },

            messageCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.message);
            },

            privacityCheck: function() {
                return (!this.validated || this.privacity);
            },

            dataEquipment: function() {
                return Serializer.serialize({
                    'equipment-name': this.name,
                    'equipment-phone': this.phone,
                    'equipment-email': this.email,
                    'equipment-text': this.message,
                    'privacity': (this.privacity) ? 'on' : 'off',
                    'fsecure': this.fsecure,
                });
            }
            */
        },

        methods: {

            initHighlightsCarousel: function() {
                this.highlightsCarousel = new Swiper(this.$refs.highlightsCarousel, {
                    effect: 'fade',
                    watchOverflow: true,
                    simulateTouch: false,
                    pagination: {
                        el: '.swiper-pagination',
                        // dynamicBullets: true,
                        clickable: true
                    }
                });
            },

            initParticipationsCarousel: function() {
                this.participationsCarousel = new Swiper(this.$refs.participationsCarousel, {
                    watchOverflow: true,
                    simulateTouch: false,
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                    breakpoints: {
                        576: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },
                        576: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                        992: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                        }
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        // dynamicBullets: true,
                        clickable: true
                    },
                });
            },

            initNotesCarousel: function() {
                this.notesCarousel = new Swiper(this.$refs.notesCarousel, {
                    watchOverflow: true,
                    simulateTouch: false,
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                    breakpoints: {
                        576: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },
                        576: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                        992: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                        }
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        // dynamicBullets: true,
                        clickable: true
                    },
                });
            },

            initCarousels: function() {

                if (this.$refs.highlightsCarousel) {
                    this.initHighlightsCarousel();
                }

                if (this.$refs.participationsCarousel) {
                    this.initParticipationsCarousel();
                }

                if (this.$refs.notesCarousel) {
                    this.initNotesCarousel();
                }

                if (this.$refs.ssrLeadersList) {
                    this.initLeadersPanel();
                }

            },

            /*
            closeLegalModal: function() {
                noScroll.off();
                this.isLegalShown = false;
            },

            showLegalConditions: function(ev) {
                if (ev.target.tagName === 'A') {
                    ev.preventDefault();
                    noScroll.on();
                    this.isLegalShown = true;
                }
            },

            cleanErrors: function() {
                this.errors = [];
            },

            addError: function(errorMsg) {
                if (this.errors.length > 0) {
                    return;
                }

                this.errors.push(errorMsg);
            },

            validateForm: function() {
                /// error_data, data_ko & error_privacity
                /// are globally injected from PHP controller
                var isValid = true;

                this.cleanErrors();
                this.validated = true;

                if (!this.nameCheck) {
                    this.addError(error_data);
                    isValid = false;
                }

                if (!this.emailCheck) {
                    isValid = false;
                    this.addError(data_ko);
                }

                if (!this.phoneCheck) {
                    isValid = false;
                    this.addError(error_data);
                }

                if (!this.messageCheck) {
                    isValid = false;
                    this.addError(error_data);
                }

                if (!this.privacityCheck) {
                    isValid = false;
                    this.addError(error_privacity);
                }

                return isValid;
            },

            resetForm: function() {
                this.name = '';
                this.email = '';
                this.phone = '';
                this.message = '';
                this.privacity = false;

                this.validated = false;
                this.cleanErrors();
            },

            onSend: function(response) {
                var _this = this;

                if (response.data.result === 'OK') {
                    this.successMessage = response.data.message;
                    this.resetForm();
                } else {
                    this.addError(response.data.message);
                }

                Vue.nextTick(function() {
                    _this.equipmentSlides.update();
                });
            },

            sendForm: function() {

                if (this.validateForm()) {
                    axios
                        .post(this.FORM_URL, this.dataEquipment)
                        .then(this.onSend)
                        .catch(function(error) {
                            console.log(error);
                        });

                    return;
                }

                var _this = this;
                Vue.nextTick(function() {
                    _this.equipmentSlides.update();
                });
            },
            */

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                // this.$refs.fsecure.style.display = 'none';

                this.initCarousels();
            },
        },
        filters: {},

        mounted: function() {
            // this.FORM_URL = this.$refs.equipmentForm.getAttribute('action');

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {},
    });

})();
